if (typeof gsap !== 'undefined') {
  gsap.defaults({
    ease: Power4.easeOut
  });
  gsap.config({
    nullTargetWarn: false
  });
  if (typeof ScrollTrigger !== 'undefined' && typeof DrawSVGPlugin !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);
  }
}

if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

      this.validateQtyRules();
    }
    connectedCallback() {
      this.classList.add('buttons_added');
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }

      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-featured-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
      this.shop_now = this.querySelector('.product-card--shop-now');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
      if (this.shop_now) {
        this.shop_now.addEventListener('click', (event) => {
          if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          this.shop_now.classList.add('loading');
          this.shop_now.setAttribute('aria-busy', 'true');
        });
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-featured-image');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }

      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

      images.forEach(function (image) {
        window.addEventListener('load', (event) => {
          lazySizes.loader.unveil(image);
        });
      });
    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '',
        card = this,
        links = card.querySelectorAll('a.product-featured-image-link, a.product-card-title');

      swatch_list.forEach((swatch, index) => {
        window.addEventListener('load', (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });
        swatch.addEventListener('mouseover', function () {

          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              image.setAttribute('srcset', org_srcset);
            }
          }

          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          evt.preventDefault();
          evt.stopPropagation();
          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              image.setAttribute('srcset', org_srcset);
            }
          }
          swatch.classList.add('active');
          // Update product card links to selected variant
          if (swatch.dataset.href) {
            links.forEach(function (link) {
              link.setAttribute('href', swatch.dataset.href);
            });
          }
        });
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }

    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled || this.quick_add.getAttribute('aria-disabled') === 'true') {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      const formData = new FormData();

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => {
          if (!response.ok) {
            return response.text().then(text => {
              try { return JSON.parse(text); } catch (e) { throw new Error(`HTTP ${response.status}`); }
            });
          }
          return response.json();
        })
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.removeProductEvent();
        }
      }));

      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').open();
      }

    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}

/**
 *  @class
 *  @function ProductCardSmall
 */
if (!customElements.get('product-card-small')) {
  class ProductCardSmall extends HTMLElement {
    constructor() {
      super();

      this.quick_add_enabled = this.classList.contains('quick-add-to-card--true');
      this.button = this.querySelector('button');
      this.id = this.dataset.id;
      this.url = this.dataset.url;
    }
    connectedCallback() {
      if (this.quick_add_enabled) {
        this.setEventListeners();
      }
    }
    setEventListeners() {
      this.button.addEventListener('click', this.addToCart.bind(this));
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }

    addToCart() {
      this.button.classList.add('loading');
      if (!this.quick_add_enabled) {
        // quick view
      }
      this.button.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData(this.form);

      formData.append('id', this.id);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => {
          if (!response.ok) {
            return response.text().then(text => {
              try { return JSON.parse(text); } catch (e) { throw new Error(`HTTP ${response.status}`); }
            });
          }
          return response.json();
        })
        .then((response) => {
          if (response.status) {
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.button.classList.remove('loading');
          this.button.removeAttribute('aria-disabled');
        });
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));
      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').open();
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card-small', ProductCardSmall);
}

/**
 *  @class
 *  @function PanelClose
 */
class PanelClose extends HTMLElement {

  constructor() {
    super();
    let cc = document.querySelector('.click-capture');

    // Add functionality to buttons
    this.addEventListener('click', (e) => this.close_panel(e));
    document.addEventListener('keyup', (e) => {
      if (e.code) {
        if (e.code.toUpperCase() === 'ESCAPE') {
          document.querySelectorAll('.side-panel').forEach((panel) => {
            if (document.body.classList.contains('open-cc--product')) {
              document.body.classList.remove('open-cc--product');

              setTimeout(() => {
                document.querySelector('#Product-Drawer-Content').innerHTML = '';
              }, 260);
            } else {
              if (panel.classList.contains('cart-drawer')) {
                document.getElementById('cart-drawer-toggle').focus();
              }
              document.body.classList.remove('open-cc');
            }
            panel.classList.remove('active');
          });
        }
      }
    });
    cc.addEventListener('click', (e) => {
      let panel = document.querySelector('.side-panel.active');
      if (panel) {
        panel.classList.remove('active');
        document.body.classList.remove('open-cc');
      }
    });
  }

  close_panel(e) {
    e.preventDefault();
    let panel = e.target.closest('.side-panel');
    panel.classList.remove('active');
    if (document.body.classList.contains('open-cc--product')) {
      document.body.classList.remove('open-cc--product');
      setTimeout(() => {
        document.querySelector('#Product-Drawer-Content').innerHTML = '';
      }, 260);
    } else {
      document.body.classList.remove('open-cc');
    }
  }
}
customElements.define('side-panel-close', PanelClose);

/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {

    constructor() {
      super();
      this.refreshTimer = null;
      this.refreshInFlight = null;
      this.refreshAfterFlight = false;
      this.refreshWaiters = [];
      this.openAfterRefresh = false;
      this.lastRefreshCompletedAt = 0;
      this.mutationDepth = 0;
      this.mutationGeneration = 0;
      this.refreshRevision = 0;
    }

    connectedCallback() {
      let button = document.getElementById('cart-drawer-toggle');


      // Add functionality to buttons
      button?.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.add('open-cc');
        this.classList.add('active');
        this.focus();
        dispatchCustomEvent('cart-drawer:open');
      });

      this.debouncedQuantityChange = this.debouncedQuantityChange || debounce((line, quantity) => {
        this.updateQuantity(line, quantity);
      }, 300);

      this.onCartRefresh = this.onCartRefresh || (() => this.queueRefresh());
      document.removeEventListener('cart:refresh', this.onCartRefresh);
      document.addEventListener('cart:refresh', this.onCartRefresh);

      this.onCartDrawerChange = this.onCartDrawerChange || ((event) => this.onChange(event));
      this.removeEventListener('change', this.onCartDrawerChange);
      this.addEventListener('change', this.onCartDrawerChange);

      this.removeProductEvent();
    }
    onChange(event) {
      if (event.target.classList.contains('qty')) {
        const quantitySelector = event.target.closest('quantity-selector');
        const item = event.target.closest('.product-cart-item[id^="CartDrawerItem-"]');
        if (!quantitySelector || !item || !this.contains(quantitySelector)) {
          event.target.remove();
          this.queueRefresh({ delay: 100 });
          return;
        }
        this.debouncedQuantityChange(event.target.dataset.index, event.target.value);
      }
    }
    removeProductEvent() {
      let removes = this.querySelectorAll('.remove');

      removes.forEach((remove) => {
        if (remove.dataset.cartRemoveBound === 'true') return;
        remove.dataset.cartRemoveBound = 'true';
        remove.addEventListener('click', (event) => {
          event.preventDefault();
          const line = event.currentTarget?.dataset.index;
          if (!line) {
            this.queueRefresh({ delay: 100 });
            return;
          }
          this.updateQuantity(line, '0');
        });
      });
    }
    getSectionsToRender() {
      return [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    getSectionInnerHTML(html, selector) {
      if (!html) return null;

      const source = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector);

      return source ? source.innerHTML : null;
    }
    replaceSectionContents(sections) {
      if (!sections) return false;

      let cartDrawerUpdated = false;
      this.getSectionsToRender().forEach((section) => {
        const targetRoot = document.getElementById(section.id);
        const target = targetRoot?.matches(section.selector)
          ? targetRoot
          : targetRoot?.querySelector(section.selector);
        const content = this.getSectionInnerHTML(sections[section.section], section.selector);

        if (target && content !== null) {
          target.innerHTML = content;
          if (section.id === 'Cart-Drawer') cartDrawerUpdated = true;
        }
      });

      if (cartDrawerUpdated) {
        this.removeProductEvent();
        window.initDiscountAccordion?.();
        window.DiscountManager?.initCheckoutInterception?.();
      }

      return cartDrawerUpdated;
    }
    updateQuantity(line, quantity) {
      const lineNumber = Number(line);
      const item = Number.isInteger(lineNumber) && lineNumber > 0
        ? this.querySelector(`#CartDrawerItem-${lineNumber}`)
        : null;
      if (!item) {
        this.queueRefresh({ delay: 100 });
        return;
      }

      item.classList.add('thb-loading');
      const body = JSON.stringify({
        line: lineNumber,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });
      let mutationFinished = false;
      this.beginMutation();
      fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
          }
          return response.text();
        })
        .then(async (state) => {
          const parsedState = JSON.parse(state);
          this.endMutation();
          mutationFinished = true;
          const refreshed = await this.queueRefresh();
          if (!refreshed && parsedState.sections) {
            this.replaceSectionContents(parsedState.sections);
          }
          dispatchCustomEvent('line-item:change:end', {
            quantity: quantity,
            cart: parsedState
          });
          this.querySelector(`#CartDrawerItem-${lineNumber}`)?.classList.remove('thb-loading');
        })
        .catch((e) => {
          console.error('Cart drawer update error:', e);
          this.querySelector(`#CartDrawerItem-${lineNumber}`)?.classList.remove('thb-loading');
        })
        .finally(() => {
          if (!mutationFinished) this.endMutation();
        });
    }
    open() {
      const wasOpen = this.classList.contains('active');
      document.body.classList.add('open-cc');
      this.classList.add('active');
      if (!wasOpen) {
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    queueRefresh(options = {}) {
      const delay = Number.isFinite(options.delay) ? Math.max(0, options.delay) : 180;

      if (options.open) this.openAfterRefresh = true;
      this.refreshRevision += 1;

      const queuedRefresh = new Promise((resolve) => {
        this.refreshWaiters.push(resolve);
      });

      if (this.mutationDepth === 0) {
        if (this.refreshInFlight) {
          this.refreshAfterFlight = true;
        } else {
          this.scheduleRefresh(delay);
        }
      }

      return queuedRefresh;
    }
    scheduleRefresh(delay = 180) {
      if (this.refreshTimer) return;
      this.refreshTimer = setTimeout(() => {
        this.refreshTimer = null;
        this.flushRefresh();
      }, delay);
    }
    beginMutation() {
      this.mutationDepth += 1;
      this.mutationGeneration += 1;
      this.lastRefreshCompletedAt = 0;

      if (this.refreshTimer) {
        clearTimeout(this.refreshTimer);
        this.refreshTimer = null;
      }
      if (this.refreshInFlight) this.refreshAfterFlight = true;
    }
    endMutation() {
      this.mutationDepth = Math.max(0, this.mutationDepth - 1);
      if (this.mutationDepth !== 0 || this.refreshWaiters.length === 0) return;

      if (this.refreshInFlight) {
        this.refreshAfterFlight = true;
      } else {
        this.scheduleRefresh();
      }
    }
    async flushRefresh() {
      if (this.mutationDepth !== 0) {
        this.refreshAfterFlight = true;
        return false;
      }
      if (this.refreshInFlight) {
        this.refreshAfterFlight = true;
        return false;
      }

      const requestMutationGeneration = this.mutationGeneration;
      const requestRefreshRevision = this.refreshRevision;
      this.refreshAfterFlight = false;
      this.refreshInFlight = this.fetchLatestSections();

      let sections = null;
      try {
        sections = await this.refreshInFlight;
      } catch (error) {
        console.error('Cart drawer refresh error:', error);
      }

      const staleBeforeRender = (
        this.mutationDepth !== 0
        || requestMutationGeneration !== this.mutationGeneration
        || requestRefreshRevision !== this.refreshRevision
        || this.refreshAfterFlight
      );
      let success = false;

      if (sections && !staleBeforeRender) {
        try {
          success = this.replaceSectionContents(sections);
        } catch (error) {
          console.error('Cart drawer render error:', error);
        }
      }

      const needsAnotherRefresh = (
        this.mutationDepth !== 0
        || requestMutationGeneration !== this.mutationGeneration
        || requestRefreshRevision !== this.refreshRevision
        || this.refreshAfterFlight
      );
      this.refreshInFlight = null;

      if (needsAnotherRefresh) {
        this.refreshAfterFlight = false;
        if (this.mutationDepth === 0) this.scheduleRefresh();
        return false;
      }

      if (success) this.lastRefreshCompletedAt = Date.now();
      const waiters = this.refreshWaiters.splice(0);
      waiters.forEach((resolve) => resolve(success));

      if (success && this.openAfterRefresh) {
        this.openAfterRefresh = false;
        this.open();
      }

      return success;
    }
    async fetchLatestSections() {
      const sections = 'cart-drawer,cart-bubble';
      const url = `${window.location.pathname}?sections=${sections}&_cart_refresh=${Date.now()}`;
      const sectionFetch = window.__ieGeekNativeFetch || window.fetch.bind(window);

      for (let attempt = 0; attempt < 2; attempt += 1) {
        try {
          const response = await sectionFetch(url, {
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            },
            credentials: 'same-origin',
            cache: 'no-store'
          });

          if (!response.ok) {
            const retryable = response.status === 429
              || response.status === 408
              || response.status === 425
              || response.status === 500
              || response.status === 502
              || response.status === 503
              || response.status === 504;

            if (retryable && attempt === 0) {
              const retryDelay = response.status === 429
                ? this.getRetryDelay(response.headers.get('Retry-After'))
                : 750;
              await new Promise((resolve) => setTimeout(resolve, retryDelay));
              continue;
            }

            console.error('Cart drawer refresh error:', new Error(`HTTP ${response.status}`));
            return null;
          }
          const parsedState = await response.json();
          if (typeof parsedState?.['cart-drawer'] !== 'string') {
            throw new Error('Cart drawer section missing from response');
          }

          return parsedState;
        } catch (error) {
          if (attempt === 0) {
            await new Promise((resolve) => setTimeout(resolve, 750));
            continue;
          }
          console.error('Cart drawer refresh error:', error);
        }
      }

      return null;
    }
    getRetryDelay(retryAfterHeader) {
      if (retryAfterHeader) {
        const retryAfterSeconds = Number(retryAfterHeader);
        if (Number.isFinite(retryAfterSeconds) && retryAfterSeconds >= 0) {
          return Math.min(Math.max(retryAfterSeconds * 1000, 500), 3000);
        }

        const retryAt = Date.parse(retryAfterHeader);
        if (Number.isFinite(retryAt)) {
          return Math.min(Math.max(retryAt - Date.now(), 500), 3000);
        }
      }

      return 1000;
    }
    refresh(options = {}) {
      return this.queueRefresh(options);
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}
/**
 * Make xcotton's DE default-on shipping protection card a real opt-in control.
 * The app's default-on template has no checkbox or click handler, while the
 * cart redesign previously drew a checkbox-looking pseudo element over it.
 */
if (!window.ieGeekShippingProtectionToggleInitialized) {
  window.ieGeekShippingProtectionToggleInitialized = true;

  class IeGeekShippingProtectionToggle {
    constructor() {
      this.productInfo = null;
      this.cartSnapshot = null;
      this.protectionPrice = 0;
      this.visualChecked = false;
      this.enhanceTimer = null;
      this.syncPromise = null;
      this.reconcilePromise = null;
      this.desiredChecked = null;
      this.pendingUserChoice = null;
      this.explicitChoice = null;
      this.enhancedTitle = null;
      this.cartRequestPromise = null;
      this.optOutStorageKey = 'iegeek-shipping-protection-opt-out';

      // Capture the interaction before xcotton can also toggle the same card.
      document.addEventListener('click', this.onClick.bind(this), true);
      document.addEventListener('keydown', this.onKeyDown.bind(this), true);
      document.addEventListener('line-item:change:end', () => this.scheduleEnhance());
      document.addEventListener('cart:item-added', () => this.scheduleEnhance());

      this.observer = new MutationObserver(() => {
        const title = this.findTitle();
        if (title && title !== this.enhancedTitle) this.scheduleEnhance();
      });
      const start = () => {
        this.observer.observe(document.body, { childList: true, subtree: true });
        this.enhance();
        this.removeOrphanProtection();
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start, { once: true });
      } else {
        start();
      }
    }

    endpoint(path) {
      const root = theme?.routes?.root_url || '/';
      return `${root.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
    }

    request(url, { method = 'GET', body = null } = {}) {
      return new Promise((resolve, reject) => {
        const nativeXHR = window.__ieGeekNativeXHR;
        const Request = nativeXHR?.Constructor || window.XMLHttpRequest;
        const request = new Request();
        const open = nativeXHR?.open || request.open;
        const send = nativeXHR?.send || request.send;
        const setRequestHeader = nativeXHR?.setRequestHeader || request.setRequestHeader;

        open.call(request, method, url, true);
        setRequestHeader.call(request, 'Accept', 'application/json');
        if (body !== null) {
          setRequestHeader.call(request, 'Content-Type', 'application/json');
        }
        request.timeout = 15000;
        request.onload = () => {
          if (request.status < 200 || request.status >= 300) {
            reject(new Error(`Shipping protection request failed: HTTP ${request.status}`));
            return;
          }

          try {
            resolve(request.responseText ? JSON.parse(request.responseText) : null);
          } catch (error) {
            reject(new Error('Shipping protection returned an invalid response'));
          }
        };
        request.onerror = () => reject(new Error('Shipping protection request failed'));
        request.ontimeout = () => reject(new Error('Shipping protection request timed out'));
        request.onabort = () => reject(new Error('Shipping protection request was aborted'));
        send.call(request, body);
      });
    }

    getCart() {
      if (!this.cartRequestPromise) {
        this.cartRequestPromise = this.request(this.endpoint('cart.js')).finally(() => {
          this.cartRequestPromise = null;
        });
      }
      return this.cartRequestPromise;
    }

    getXcottonWidget() {
      return window.__xcotton_common_seller__
        ?.processor
        ?.ShippingProtectionFlow
        ?.ShippingProtectionWidget || null;
    }

    getXcottonProtectionPrice() {
      const widget = this.getXcottonWidget();
      const model = widget?.model || widget?.controller?.model;
      const rawState = typeof model?._data === 'function' ? model._data() : null;
      const price = Number(rawState?.totalPriceInt ?? model?.totalPriceInt);

      if (Number.isFinite(price) && price > 0) return price;

      const priceNode = document.querySelector(
        '#Cart-Drawer #xcottonWrapper .xcotton_price .money:not(.text-through), '
        + '#Cart-Drawer #xcottonWrapper .xcotton_price .xcotton-money:not(.text-through):not(.xcotton-money-strike)'
      );

      return this.parseMoneyToCents(priceNode?.textContent);
    }

    syncXcottonState(checked) {
      const widget = this.getXcottonWidget();
      const model = widget?.model || widget?.controller?.model;
      const rawState = typeof model?._data === 'function' ? model._data() : null;
      if (!rawState || !Object.prototype.hasOwnProperty.call(rawState, 'switchStateAction')) {
        return false;
      }

      try {
        // Both setActionState() and model.switchStateAction use xcotton's
        // reactive setter and rebuild the complete widget. Mutating the
        // backing data keeps checkout state aligned without emitting redraws.
        rawState.switchStateAction = checked;
        const cacheState = {
          state: checked,
          conditionState: Boolean(rawState.switchStateCondition)
        };
        if (typeof widget?.setStateToCache === 'function') {
          widget.setStateToCache(cacheState);
        } else if (typeof model?.setStateToCache === 'function') {
          model.setStateToCache(cacheState);
        } else {
          widget?.controller?.setStateToCache?.(cacheState);
        }
        return true;
      } catch (error) {
        console.error('Shipping protection plugin state error:', error);
        return false;
      }
    }

    refreshXcottonTotal() {
      const widget = this.getXcottonWidget();
      const totalView = widget?.SPView;

      if (typeof totalView?._buildTotalPrice === 'function') {
        return Promise.resolve(totalView._buildTotalPrice.call(totalView)).catch((error) => {
          console.error('Shipping protection native total update error:', error);
        });
      }

      // Older xcotton builds expose only the controller notification.
      widget?.controller?.cartUIChange?.();
      return Promise.resolve();
    }

    isProtectionItem(item) {
      const handle = String(item?.handle || '').toLowerCase();
      const sku = String(item?.sku || '').toUpperCase();
      const title = String(item?.product_title || item?.title || '').toLowerCase();
      return handle === 'shipping-protection'
        || sku.startsWith('XMHPACELSKU')
        || title === 'shipping protection';
    }

    scheduleEnhance() {
      clearTimeout(this.enhanceTimer);
      this.enhanceTimer = setTimeout(() => this.enhance(), 80);
    }

    findTitle() {
      return document.querySelector(
        '#Cart-Drawer #xcottonWrapper.xcotton_theme_defaultOn .xcotton_bd_title_txt'
      );
    }

    enhance() {
      const title = this.findTitle();
      if (!title || title === this.enhancedTitle) return;

      this.enhancedTitle = title;

      title.setAttribute('role', 'checkbox');
      title.setAttribute('tabindex', '0');
      title.setAttribute('aria-label', 'Versandschutz');

      // xcotton redraws this node after every change. Reuse the last visual
      // state so a redraw never flashes back to the default checked state.
      if (!title.hasAttribute('aria-checked')) {
        this.setVisualState(this.visualChecked);
      }

      if (this.explicitChoice !== null) {
        this.syncXcottonState(this.explicitChoice);
        this.setVisualState(this.explicitChoice);
        return;
      }
      this.syncState(title);
    }

    getTitles() {
      return document.querySelectorAll(
        '#Cart-Drawer #xcottonWrapper.xcotton_theme_defaultOn .xcotton_bd_title_txt[role="checkbox"]'
      );
    }

    setVisualState(checked) {
      this.visualChecked = checked;
      this.getTitles().forEach((title) => {
        title.setAttribute('aria-checked', String(checked));
        title.classList.toggle('checked', checked);
      });
    }

    setBusy(busy) {
      this.getTitles().forEach((title) => {
        if (busy) {
          title.setAttribute('aria-busy', 'true');
        } else {
          title.removeAttribute('aria-busy');
        }
      });
    }

    cartPreferenceKey(cart) {
      return String(cart?.token || 'current-cart');
    }

    isOptedOut(cart) {
      try {
        return sessionStorage.getItem(this.optOutStorageKey) === this.cartPreferenceKey(cart);
      } catch (error) {
        return false;
      }
    }

    setOptedOut(cart, optedOut) {
      try {
        if (optedOut) {
          sessionStorage.setItem(this.optOutStorageKey, this.cartPreferenceKey(cart));
        } else {
          sessionStorage.removeItem(this.optOutStorageKey);
        }
      } catch (error) {
        // Shipping protection must still work when storage is unavailable.
      }
    }

    syncState(title, { allowDefault = false } = {}) {
      if (this.reconcilePromise || this.syncPromise) return this.syncPromise;

      this.syncPromise = (async () => {
        try {
          const cart = await this.getCart();
          if (!document.contains(title) || this.reconcilePromise) return;

          this.cartSnapshot = cart;
          const checked = cart.items.some((item) => this.isProtectionItem(item));
          const hasMerchandise = cart.items.some((item) => !this.isProtectionItem(item));
          const widget = this.getXcottonWidget();

          if (this.explicitChoice === null && this.isOptedOut(cart)) {
            this.explicitChoice = false;
          }

          // Once the customer has made a choice, never let xcotton's
          // default-on state overwrite it after the widget rebuilds.
          if (this.explicitChoice !== null) {
            const explicitChoice = this.explicitChoice;
            this.syncXcottonState(explicitChoice);
            this.setVisualState(explicitChoice);
            this.updateDisplayedTotal(cart, explicitChoice);
            return;
          }

          // When xcotton is ready, its saved/default state is the source of
          // truth, matching the UK implementation and its total-price logic.
          if (widget && typeof widget.getState === 'function') {
            const pluginChecked = Boolean(widget.getState());
            const pluginPrice = this.getXcottonProtectionPrice();
            if (pluginPrice > 0) this.protectionPrice = pluginPrice;
            this.setVisualState(pluginChecked);
            this.updateDisplayedTotal(cart, pluginChecked);
            return;
          }

          if (checked) {
            this.setOptedOut(cart, false);
            this.setVisualState(true);
            this.updateDisplayedTotal(cart, true);
          } else if (hasMerchandise && allowDefault && !this.isOptedOut(cart)) {
            this.setVisualState(true);
            this.syncXcottonState(true);
            this.updateDisplayedTotal(cart, true);
          } else {
            this.setVisualState(false);
            this.updateDisplayedTotal(cart, false);
          }
        } catch (error) {
          console.error('Shipping protection state error:', error);
        }
      })().finally(() => {
        this.syncPromise = null;
      });

      return this.syncPromise;
    }

    onClick(event) {
      const title = event.target.closest(
        '#Cart-Drawer #xcottonWrapper.xcotton_theme_defaultOn .xcotton_bd_title_txt'
      );
      if (!title || event.target.closest('#xcotton-tip')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.toggle(title, true);
    }

    onKeyDown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const title = event.target.closest(
        '#Cart-Drawer #xcottonWrapper.xcotton_theme_defaultOn .xcotton_bd_title_txt'
      );
      if (!title) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.toggle(title, true);
    }

    async getCalculator() {
      if (typeof window.__xcotton_calculate__ === 'function') {
        return window.__xcotton_calculate__;
      }

      const startedAt = Date.now();
      while (Date.now() - startedAt < 8000) {
        await new Promise((resolve) => setTimeout(resolve, 100));
        if (typeof window.__xcotton_calculate__ === 'function') {
          return window.__xcotton_calculate__;
        }
      }

      throw new Error('Shipping protection calculator is not ready');
    }

    async getProductInfo() {
      if (!this.productInfo) {
        this.productInfo = await this.request(
          `${this.endpoint('products/shipping-protection.js')}?r=xcotton&_=${Date.now()}`
        );
      }
      return this.productInfo;
    }

    async calculateProtection(cart) {
      const calculate = await this.getCalculator();
      const productInfo = await this.getProductInfo();
      const calculation = calculate({
        cartJson: cart,
        shopifyProductInfo: productInfo,
        isReportComputeId: true
      })?.computeResult;
      const variantId = Number(calculation?.extId);

      if (!Number.isInteger(variantId) || variantId <= 0 || Number(calculation?.totalPriceInt) <= 0) {
        throw new Error(calculation?.computeMsg || 'Shipping protection is unavailable for this cart');
      }

      this.protectionPrice = Number(calculation.totalPriceInt);
      return calculation;
    }

    formatCartMoney(cents, currency = 'EUR') {
      const moneyFormat = window.theme?.settings?.money_with_currency_format;
      if (typeof window.formatMoney === 'function' && moneyFormat) {
        return window.formatMoney(cents, moneyFormat);
      }
      if (typeof window.Shopify?.formatMoney === 'function' && moneyFormat) {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }

      try {
        return new Intl.NumberFormat('de-DE', {
          style: 'currency',
          currency: currency || 'EUR'
        }).format(cents / 100);
      } catch (error) {
        return `${(cents / 100).toFixed(2).replace('.', ',')} €`;
      }
    }

    getMoneyText(formattedMoney) {
      const value = String(formattedMoney ?? '');
      if (!value.includes('<')) return value;

      const template = document.createElement('template');
      template.innerHTML = value;
      return template.content.textContent || '';
    }

    parseMoneyToCents(value) {
      const cleaned = String(value ?? '')
        .replace(/[\s\u00a0]/g, '')
        .replace(/[^0-9,.-]/g, '');
      if (!cleaned) return 0;

      const commaIndex = cleaned.lastIndexOf(',');
      const dotIndex = cleaned.lastIndexOf('.');
      const separatorIndex = Math.max(commaIndex, dotIndex);
      const decimalDigits = separatorIndex >= 0 ? cleaned.length - separatorIndex - 1 : 0;
      const hasDecimalSeparator = separatorIndex >= 0 && decimalDigits > 0 && decimalDigits <= 2;
      const whole = hasDecimalSeparator
        ? cleaned.slice(0, separatorIndex).replace(/[^0-9-]/g, '')
        : cleaned.replace(/[^0-9-]/g, '');
      const fraction = hasDecimalSeparator
        ? cleaned.slice(separatorIndex + 1).replace(/[^0-9]/g, '')
        : '';
      const amount = Number(fraction ? `${whole}.${fraction}` : whole);

      return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
    }

    getDisplayedTotalCents() {
      const total = document.querySelector('#Cart-Drawer .cart-total-current');
      if (!total) return 0;

      const money = total.querySelector('.transcy-money') || total;
      const visibleTotal = this.parseMoneyToCents(money.textContent);
      if (visibleTotal > 0) return visibleTotal;

      const storedTotal = Number(total.dataset.cartTotalCents);
      return Number.isFinite(storedTotal) && storedTotal > 0 ? storedTotal : 0;
    }

    setDisplayedTotal(cents, currency = 'EUR') {
      const displayedTotal = Math.max(0, Number(cents) || 0);
      const formattedTotal = this.formatCartMoney(displayedTotal, currency);
      const moneyText = this.getMoneyText(formattedTotal);

      document.querySelectorAll('#Cart-Drawer .cart-total-current').forEach((total) => {
        // Preserve Transcy's wrapper so changing protection never replaces the
        // visible amount node or causes a translation observer redraw.
        const money = total.querySelector('.transcy-money') || total;
        if (money.textContent !== moneyText) money.textContent = moneyText;
        total.dataset.cartTotalCents = String(displayedTotal);
      });
    }

    updateDisplayedTotalByDelta(checked, nextChecked, protectionPrice) {
      const price = Number(protectionPrice);
      const currentTotal = this.getDisplayedTotalCents();
      if (!Number.isFinite(price) || price <= 0 || currentTotal <= 0) return false;

      const direction = Number(Boolean(nextChecked)) - Number(Boolean(checked));
      const displayedTotal = currentTotal + (direction * price);
      this.setDisplayedTotal(displayedTotal, this.cartSnapshot?.currency || 'EUR');
      return true;
    }

    async updateDisplayedTotal(cart, checked) {
      try {
        const currentCart = cart || await this.getCart();
        this.cartSnapshot = currentCart;

        const protectionTotal = currentCart.items.reduce((total, item) => {
          if (!this.isProtectionItem(item)) return total;
          const linePrice = Number(item.final_line_price ?? item.line_price);
          if (Number.isFinite(linePrice)) return total + linePrice;
          return total + (Number(item.final_price ?? item.price) || 0) * (Number(item.quantity) || 1);
        }, 0);

        let protectionPrice = protectionTotal
          || this.getXcottonProtectionPrice()
          || this.protectionPrice;
        if (protectionPrice > 0) this.protectionPrice = protectionPrice;
        if (checked && protectionPrice <= 0) {
          protectionPrice = Number((await this.calculateProtection(currentCart)).totalPriceInt) || 0;
        }

        const baseTotal = Math.max(0, Number(currentCart.total_price || 0) - protectionTotal);
        const displayedTotal = baseTotal + (checked ? protectionPrice : 0);
        this.setDisplayedTotal(displayedTotal, currentCart.currency);
      } catch (error) {
        console.error('Shipping protection total update error:', error);
      }
    }

    async addProtection(cart) {
      const calculation = await this.calculateProtection(cart);
      const variantId = Number(calculation.extId);
      await this.request(this.endpoint('cart/add.js'), {
        method: 'POST',
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      return this.request(this.endpoint('cart/update.js'), {
        method: 'POST',
        body: JSON.stringify({ attributes: { xcsp_qid: calculation.disComputeId || '' } })
      });
    }

    async removeProtection(cart) {
      const updates = {};
      cart.items.forEach((item) => {
        if (this.isProtectionItem(item)) updates[item.key] = 0;
      });
      if (!Object.keys(updates).length) return cart;

      return this.request(this.endpoint('cart/update.js'), {
        method: 'POST',
        body: JSON.stringify({ updates, attributes: { xcsp_qid: '' } })
      });
    }

    async refreshDrawer() {
      const drawer = document.getElementById('Cart-Drawer');
      if (drawer && typeof drawer.refresh === 'function') {
        await drawer.refresh();
      } else {
        dispatchCustomEvent('cart:refresh');
      }
      this.scheduleEnhance();
    }

    toggle(title, userInitiated = false) {
      const checked = title.getAttribute('aria-checked') !== 'false';
      const nextChecked = !checked;
      const pluginPrice = this.getXcottonProtectionPrice();
      if (pluginPrice > 0) this.protectionPrice = pluginPrice;
      if (userInitiated) {
        this.explicitChoice = nextChecked;
        this.setOptedOut(this.cartSnapshot, !nextChecked);
      }
      this.setVisualState(nextChecked);

      // xcotton owns adding/removing its product at checkout. Keep only its
      // saved state here so a click never starts a cart request that can
      // overwrite the visible total with stale data.
      this.syncXcottonState(nextChecked);
      this.updateDisplayedTotal(this.cartSnapshot, nextChecked);
    }

    queueState(checked, userInitiated = false) {
      this.desiredChecked = checked;
      if (userInitiated) this.pendingUserChoice = checked;
      this.setVisualState(checked);

      if (!this.reconcilePromise) {
        this.reconcilePromise = this.reconcileState().finally(() => {
          this.reconcilePromise = null;
        });
      }
      return this.reconcilePromise;
    }

    async reconcileState() {
      this.setBusy(true);

      try {
        while (this.desiredChecked !== null) {
          const targetChecked = this.desiredChecked;
          const userChoice = this.pendingUserChoice;
          this.desiredChecked = null;
          this.pendingUserChoice = null;

          const cart = await this.getCart();
          const checked = cart.items.some((item) => this.isProtectionItem(item));

          if (userChoice !== null) {
            this.setOptedOut(cart, !userChoice);
          }

          if (targetChecked && !checked) {
            this.cartSnapshot = await this.addProtection(cart);
          } else if (!targetChecked && checked) {
            this.cartSnapshot = await this.removeProtection(cart);
          } else {
            this.cartSnapshot = cart;
          }

          // A click during a request wins visually and is handled next.
          if (this.desiredChecked === null) {
            this.setVisualState(targetChecked);
            await this.updateDisplayedTotal(this.cartSnapshot, targetChecked);
            await this.refreshXcottonTotal();
          }
        }
      } catch (error) {
        console.error('Shipping protection update error:', error);
        this.desiredChecked = null;
        this.pendingUserChoice = null;
        this.scheduleEnhance();
      } finally {
        this.setBusy(false);
      }
    }

    async removeOrphanProtection() {
      try {
        const cart = await this.getCart();
        const protectionItems = cart.items.filter((item) => this.isProtectionItem(item));
        const merchandiseItems = cart.items.filter((item) => !this.isProtectionItem(item));
        if (protectionItems.length && !merchandiseItems.length) {
          await this.removeProtection(cart);
          await this.refreshDrawer();
        }
      } catch (error) {
        console.error('Shipping protection cleanup error:', error);
      }
    }
  }

  new IeGeekShippingProtectionToggle();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll(".thb-widget-title.collapsible").forEach((button) => {
      button.addEventListener("click", (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

/**
 *  @class
 *  @function CustomSelect
 */
if (!customElements.get('custom-select')) {
  class CustomSelect extends HTMLElement {
    constructor() {
      super();
      this.detailsements = {
        form: this.closest('form'),
        input: this.querySelector('input'),
        button: this.querySelector('.custom-select--button'),
        panel: this.querySelector('.custom-select--list'),
      };
      this.autoClose = this.dataset.autoClose;
      this.detailsements.button.addEventListener('click', this.toggleSelector.bind(this));
      this.detailsements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.detailsements.panel.querySelectorAll('button').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.detailsements.button.setAttribute('aria-expanded', 'false');
      this.classList.remove('custom-select--active');
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.detailsements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.detailsements.input.value = event.currentTarget.dataset.value;
      this.detailsements.input.dispatchEvent(new Event('change'));
      this.detailsements.button.querySelector('.custom-select--text').textContent = event.currentTarget.textContent;
      if (this.detailsements.form) {
        this.detailsements.form.dispatchEvent(new Event('input'));
      }
      if (this.autoClose) {
        this.classList.remove('custom-select--active');
      }
    }

    toggleSelector(event) {
      event.preventDefault();
      this.classList.toggle('custom-select--active');
      if (this.classList.contains('custom-select--active')) {
        this.detailsements.button.focus();
        this.detailsements.button.setAttribute('aria-expanded', (this.detailsements.button.getAttribute('aria-expanded') === 'false').toString());
      } else {
        this.hidePanel();
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.classList.contains('custom-select--button');
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('custom-select', CustomSelect);
}
/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form.querySelectorAll('input[name="locale_code"], input[name="country_code"]');
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 200);
      this.inputs.forEach(item => item.addEventListener('change', this.debouncedOnSubmit.bind(this)));
    }
    onSubmitHandler(event) {
      if (this.form) this.form.submit();
    }
  }
  customElements.define('localization-form', LocalizationForm);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {

    }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
          e.preventDefault();
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      this.buttons[i].classList.add('tab-active');

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.panels[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

  }
  fetchProducts() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        this.classList.add('product-recommendations--loaded');

      })
      .catch(e => {
        console.error(e);
      });
  }
  connectedCallback() {
    this.fetchProducts();
  }
}

customElements.define('product-recommendations', ProductRecommendations);

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    static getCache() {
      if (!QuickView.cache) {
        QuickView.cache = new Map();
      }
      return QuickView.cache;
    }
    static getHref(productHandle) {
      if (!productHandle) return '';
      return `${theme.routes.root_url}/products/${productHandle}?view=quick-view`.replace('//', '/');
    }
    static prefetch(productHandle) {
      const href = QuickView.getHref(productHandle);
      const cache = QuickView.getCache();
      if (!href || cache.has(href)) return;
      fetch(href, { method: 'GET' })
        .then((response) => response.text())
        .then(text => {
          const content = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content');
          if (content) cache.set(href, content.innerHTML);
        })
        .catch(() => {});
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture--product');
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));
      this.cc.addEventListener('click', this.setupCCEventListener.bind(this));

    }
    setupCCEventListener(e) {
      this.body.classList.remove('open-cc--product');
      this.drawer.classList.remove('active');

      setTimeout(() => {
        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = '';
      }, 260);

    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = QuickView.getHref(productHandle);

      // remove double `/` in case shop might have /en or language in URL
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      const cache = QuickView.getCache();
      if (cache.has(href)) {
        this.renderQuickview(cache.get(href), href, productHandle);
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          cache.set(href, sectionInnerHTML);
          this.renderQuickview(sectionInnerHTML, href, productHandle);

        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            if (!js_file.src || document.querySelector('script[src="' + js_file.src + '"]')) return;
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);



        this.body.classList.add('open-cc--product');
        this.drawer.classList.add('active');

        this.drawer.querySelector('.side-panel-close').focus();

        if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) {
          setTimeout(() => {
            let slider = this.drawer.querySelector('#Product-Slider');
            if (!slider || typeof slider.reInit !== 'function') return;
            slider.reInit();
            window.dispatchEvent(new Event('resize'));
          }, 100);
        }

        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });

        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function AnimatedMarkers
 */
class AnimatedMarkers {

  constructor() {
    this.markers = document.querySelectorAll('.svg-marker path');
    this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';

    if (this.animations_enabled && this.markers.length) {
      this.setupEventListeners();
    }
  }
  setupEventListeners() {
    this.markers.forEach((marker, i) => {
      gsap.from(marker, {
        duration: 1,
        ease: 'power4.inOut',
        drawSVG: "0%",
        scrollTrigger: {
          trigger: marker,
          start: 'top 70%',
          end: 'bottom 80%'
        }
      });
    });
  }

}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds != 'undefined' && recentIds != null) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

document.addEventListener('DOMContentLoaded', () => {

  if (typeof AnimatedMarkers !== 'undefined') {
    new AnimatedMarkers();
  }
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }
});
